import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { UserService } from 'netsocial-posting/src/app/services/user/user.service';
import {
  ApiRequestService,
  NetSocialAccountFields,
} from 'netsocial-lib/src/app/services/api-request/api-request.service';
import { PermissionInfo } from 'netsocial-lib/src/app/interfaces/permission-info';
@Injectable({
  providedIn: 'root',
})
export class RouteDataGuard implements CanActivate {
  public contextOwner?: NetSocialAccountFields;
  constructor(
    private router: Router,
    private userService: UserService,
    private apiRequest: ApiRequestService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
    redirect = true
  ): boolean {
    this.apiRequest
      .getContextOwner()
      .subscribe((contextOwner) => (this.contextOwner = contextOwner));
    const permissions = this.userService.currentUser?.permissionInfo.permissions;
    const routeData = route.data ? route.data : {};
    // @ts-ignore
    // ADD missing key to types
    permissions?.agency = this.contextOwner?.agency === '1' ? 'enabled' : 'disabled';

    const reqRestrictions: string[] =
      routeData.canActivate && routeData.canActivate.restrictions
        ? routeData.canActivate.restrictions
        : [];

    const reqPermissions: string[] =
      routeData.canActivate && routeData.canActivate.permissions
        ? routeData.canActivate.permissions
        : [];
    const reqRoles: string[] =
      routeData.canActivate && routeData.canActivate.roles ? routeData.canActivate.roles : [];

    let canActivate =
      reqPermissions.length || reqRoles.length || reqRestrictions.length > 0 ? false : true;

    // Current Implementation will let a user into a page if
    // they have any of the roles or permission configured for the route

    canActivate = reqRestrictions.reduce(
      (_canActivate, restriction: keyof PermissionInfo['permissions']) => {
        if (permissions && permissions[restriction] === 'disabled') {
          _canActivate = true;
        }
        return _canActivate;
      },
      canActivate
    );

    canActivate = reqPermissions.reduce(
      (_canActivate, permission: keyof PermissionInfo['permissions']) => {
        if (permissions && permissions[permission] === 'enabled') {
          _canActivate = true;
        }
        return _canActivate;
      },
      canActivate
    );

    canActivate = reqRoles.reduce((_canActivate, role) => {
      if (this.userService.currentUser?.roleLabel === role) {
        _canActivate = true;
      }
      return _canActivate;
    }, canActivate);

    if (canActivate) {
      return true;
    } else {
      if (redirect) {
        if (routeData.redirect) {
          this.router.navigateByUrl('/' + routeData.redirect);
        } else {
          this.router.navigateByUrl(this.router.createUrlTree([this.userService.homePage]));
        }
      }
      return false;
    }
  }
}
